import React from 'react'
import {ArrowLeft} from 'lucide-react';
import { useTranslation } from 'react-i18next';

const BackButton = ({onClick}) => {

    const { t } = useTranslation();

    return (
        <div className='fixed bottom-6 left-6 z-50'>
            <button
                onClick={onClick}
                className='group relative flex items-center gap-3 px-6 py-3 bg-gradient-to-r from-gray-600 to-gray-500 text-white text-sm font-medium rounded-lg
                shadow-md hover:shadow-lg transform hover:-translate-y-0.5
                transition-all duration-200 ease-in-out
                focus:outline-none focus:ring-2 focus:ring-gray-500 focus:ring-offset-2'
            >
                <ArrowLeft 
                    size={20}
                    className='relative z-10 transform group-hover:-translate-x-1 transition-transform duration-200'
                />
                <span className="relative z-10">{t("form.button.back")}</span>
                <div className="absolute inset-0 bg-gradient-to-r from-gray-500 to-gray-400 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity duration-200" />
            </button>
        </div>
    );
}

export default BackButton;